import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Numerar',
    [PaymentMethodsEnum.Online]: 'Online',
    [PaymentMethodsEnum.InStoreCard]: 'Card în restaurant',
  },
};
